import localized from "../../../i18n";
export const required = (value) => value ? "" : localized.This_Field_is_Required;

export const emailvalidate = (value = "") => !/^[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? localized.Email_is_not_valid_email
    : undefined;

export const strongPassword = value => {
    if (value){
        if (!/^(?=.*[a-zA-Z])(?=.*[0-9])(?=.{8,})/g.test(value)){
            return localized.error_weak_password
        }
    } else {
        return localized.This_Field_is_Required
    }
}

export const matchesPassword = (value, allValues) => {
    if (value){
        if (value !== allValues.password){
            return localized.error_invalid_confirmation
        }
    } else {
        return localized.This_Field_is_Required
    }
}

export const emailValidateWithRequired = (value) => {
    if (value){
        if (!/^[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)){
            return localized.Email_is_not_valid_email
        }
    } else {
        return localized.This_Field_is_Required
    }
}